<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <div class="row">
            <div class="col-12 table-container">
              <data-table
                v-model="table"
                :get-page="getPage"
                :has-details-row="true"
                :per-page="250"
                :selectable-rows="false"
              >
                <template #row-details="row">
                  <conditions-table-details-row :row="row" />
                </template>
                <template #head(company)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.company"
                    input-type="number"
                  />
                </template>
                <template #head(accountOrGroup)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.accountOrGroup"
                    input-type="number"
                  />
                </template>
                <template #head(priceGroup)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.priceGroup"
                    input-type="number"
                  />
                </template>
                <template #head(priceIndicator)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.priceIndicator"
                    input-type="number"
                  />
                </template>
                <template #head(dateFrom)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.dateFrom"
                    input-type="number"
                  />
                </template>
                <template #head(dateTo)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.dateTo"
                    input-type="number"
                  />
                </template>
                <template #head(priceList)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.priceList"
                    input-type="number"
                  />
                </template>
                <template #head(priceArticleLevel)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.priceArticleLevel"
                    input-type="number"
                  />
                </template>
                <template #head(priceArticleId)="row">
                  {{ row.label }}
                  <table-filter
                    v-model="table.filter.priceArticleId"
                    input-type="number"
                  />
                </template>
              </data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import {CustomerMixin, NotificationMixin} from '../../../mixins/index';
import ConditionsTableDetailsRow from './conditions-table-details-row';
import PageHeader from '../../structure/page-header';
import TableFilter from '../../table/table-filter';

export default {
  name: 'Conditions',
  components: {PageHeader, ConditionsTableDetailsRow, DataTable, TableFilter},
  mixins: [CustomerMixin, NotificationMixin],
  data: function () {
    return {
      table: {
        rows: [],
        fields: [
          {key: 'check', label: ''},
          {key: 'company', label: this.$translate('company')},
          {key: 'accountOrGroup', label: this.$translate('account_or_group')},
          {key: 'priceGroup', label: this.$translate('price_group')},
          {key: 'priceIndicator', label: this.$translate('price_indicator')},
          {key: 'dateFrom', label: this.$translate('date_from')},
          {key: 'dateTo', label: this.$translate('date_to')},
          {key: 'priceList', label: this.$translate('price_list')},
          {key: 'priceArticleLevel', label: this.$translate('price_article_level')},
          {key: 'priceArticleId', label: this.$translate('price_article_id')},
          {key: 'primaryKey', label: this.$translate('primary_key')},
        ],
        filter: {
          company: null,
          accountOrGroup: null,
          priceGroup: null,
          priceIndicator: null,
          dateFrom: null,
          dateTo: null,
          priceList: null,
          priceArticleLevel: null,
          priceArticleId: null,
        }
      }
    };
  },
  methods: {
    async getPage(params) {
      try {
        const response = await this.customerService.getConditionsPage(params);
        return {totalCount: response.totalCount, data: response.data};
      } catch (err) {
        this.showNotification({type: 'error', message: err.message});
      }
    }
  }
};
</script>

<style scoped lang="scss">
  // @media (max-width: 991px) {
  //   .main-content {
  //     max-height: calc(100vh - 100px);
  //   }
  // }

  ::v-deep   .table {
    min-width: 1000px;

    th, td {
      &.check {
        width: 3%;
      }

      &.width-5 {
        width: 5%;
      }

      &.width-8 {
        width: 8%;
      }

      &.width-10 {
        width: 10%;
      }
    }
  }
</style>
